import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import CaseStudyRedirect from "@/components/LegacyRedirects";

export const Route = createFileRoute("/en/case-study/$slug")({
  loader: ({ params }) => loadContentMeta("case_studies", params.slug, "en"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/en/case-study/${params.slug}`, loaderData),
  component: CaseStudyRedirect,
});

